import styled from "@emotion/styled";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { FONT_WEIGHT_SEMI_BOLD } from "../utilities";

const Details = styled.div<{ $label: string }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  width: fit-content;
  max-width: 70%;

  color: ${({ theme }) => theme.generalTextIcon};

  background-color: ${({ theme }) => theme.surface};

  border-radius: 50px;

  border: solid 12px transparent;
  border-block-start: solid 10px transparent;
  padding-inline: 15px;

  overflow: hidden;

  user-select: none;

  &::before {
    content: ${({ $label }) => `"${$label}"`};

    font-size: ${({ theme }) => theme.fontSizeLarge};
    font-variant: small-caps;
    font-weight: ${FONT_WEIGHT_SEMI_BOLD};

    padding-inline-end: 8px;
  }
`;

const Container = styled.div<{ $overlay: boolean; $show: boolean }>`
  ${({ $overlay }) =>
    $overlay &&
    `
  position: absolute;
  left: 0;
  top: 0;
`}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 10px 0;

  background-color: transparent;

  user-select: none;

  opacity: ${({ $show }) => ($show ? 1 : 0)};

  pointer-events: none;

  & ${Details} {
    pointer-events: ${({ $show }) => ($show ? "auto" : "none")};
  }

  transition: all 150ms ease-in-out;
`;

const Placeholder = styled.span`
  color: ${({ theme }) => theme.generalTextIconVariant};
`;

type Props = {
  show: boolean;
  overlay?: boolean;
  objectiveText?: string;
};

export const Objective = ({ show, overlay = false, objectiveText, ...props }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <Container $show={show} $overlay={overlay} {...props}>
      <Details $label={formatMessage("objective")}>
        {objectiveText || <Placeholder>{formatMessage("objectivePlaceholder")}</Placeholder>}
      </Details>
    </Container>
  );
};

const formatStrings = {
  objective: {
    en: "objective",
  },
  objectivePlaceholder: {
    en: "Enter objective in the properties panel...",
  },
} satisfies FormatMessages;
